"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemsInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const react_hook_form_1 = require("react-hook-form");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const ItemsInput = props => {
    const { name = "orderItems" } = props;
    const form = (0, react_hook_form_1.useFormContext)();
    const value = (0, react_hook_form_1.useWatch)({ name });
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const handleAddRow = () => {
        const newValue = value.concat({
            productItemId: 0,
            amount: 1,
        });
        form.setValue(name, newValue, { shouldDirty: true });
    };
    const handleDeleteRow = (i) => {
        return () => {
            const newValue = [...value];
            newValue.splice(i, 1);
            form.setValue(name, newValue, { shouldDirty: true });
        };
    };
    const getTitle = (item) => {
        const { product, parameters } = item;
        const title = product?.title || "";
        if (parameters?.length) {
            return `${title} (${parameters.map(({ parameterValue }) => parameterValue).join(", ")})`;
        }
        return title;
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(ui_kit_1.Typography, { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: `form.labels.${name}` }), (0, jsx_runtime_1.jsx)(ui_kit_1.Tooltip, { arrow: false, title: formatMessage({ id: "form.tips.add" }), children: (0, jsx_runtime_1.jsx)(ui_kit_1.Button, { intent: "icon", "aria-label": "add", onClick: handleAddRow, children: (0, jsx_runtime_1.jsx)(icons_material_1.Add, {}) }) })] }), (0, jsx_runtime_1.jsx)(ui_kit_1.List, { children: value.map((row, i) => ((0, jsx_runtime_1.jsx)(ui_kit_1.List.Item, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, spacing: 2, children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { sx: { flexGrow: 1 }, children: (0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: `${name}[${i}].productItemId`, controller: "ecommerce/product-item", getTitle: getTitle }) }), (0, jsx_runtime_1.jsx)(material_1.Grid, { children: (0, jsx_runtime_1.jsx)(mui_inputs_core_1.NumberInput, { name: `${name}[${i}].amount`, min: 1 }) }), (0, jsx_runtime_1.jsx)(material_1.Grid, { children: (0, jsx_runtime_1.jsx)(ui_kit_1.Tooltip, { arrow: false, title: formatMessage({ id: "form.tips.delete" }), children: (0, jsx_runtime_1.jsx)(ui_kit_1.Button, { intent: "icon", "aria-label": "add", onClick: handleDeleteRow(i), children: (0, jsx_runtime_1.jsx)(icons_material_1.Delete, {}) }) }) })] }) }, row.id))) })] }));
};
exports.ItemsInput = ItemsInput;
//# sourceMappingURL=index.js.map